import Breakpoints from "core/constants/breakpoints";
import useWindowDimensions from "./useWindowDimensions";

type Props = {
  desktopBreakpoint?: number;
  tabletBreakpoint?: number;
  mobileBreakpoint?: number;
  mobile2Breakpoint?: number;
};

export default function useBreakpoints(props: Props = {}) {
  const {
    desktopBreakpoint = Breakpoints.desktop,
    tabletBreakpoint = Breakpoints.tablet,
    mobileBreakpoint = Breakpoints.mobile3,
    mobile2Breakpoint = Breakpoints.mobile4,
  } = props;
  const { width } = useWindowDimensions();

  return {
    isDesktop: width > desktopBreakpoint,
    isSemiDesktop: width > tabletBreakpoint && width < desktopBreakpoint,
    isTablet: width > mobileBreakpoint && width < tabletBreakpoint,
    isMobile: width < mobileBreakpoint,
    greaterThanDesktop: width > desktopBreakpoint,
    greaterThanTablet: width > tabletBreakpoint,
    greaterThanMobile: width > mobileBreakpoint,
    desktopWidthDiff: width - desktopBreakpoint,
    tabletWidthDiff: width - tabletBreakpoint,
    mobileWidthDiff: width - mobileBreakpoint,
    isTablet2: width >= tabletBreakpoint && width < desktopBreakpoint,
    isMobile2: width < tabletBreakpoint && width >= mobile2Breakpoint,
  };
}
